import { auth, db } from './firebase';

// Sign Up
export const registerUser = async (name, email, password) => {
  let user = await auth.createUserWithEmailAndPassword(email, password);
  const id = user.uid;
  await db.ref(`u/${id}`).set({
    name,
    email,
  });
};

// Sign In
export const doSignInWithEmailAndPassword = (email, password) =>
  auth.signInWithEmailAndPassword(email, password);

// Sign out
export const doSignOut = () =>
  auth.signOut();

// Password Reset
export const doPasswordReset = (email) =>
  auth.sendPasswordResetEmail(email);

// Password Change
export const doPasswordUpdate = (password) =>
  auth.currentUser.updatePassword(password);


export const validateEmail = (email) => {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export const uid=()=>{

  return auth.currentUser.uid;
}






// WEBPACK FOOTER //
// ./src/firebase/auth.js